import { createRoot } from 'react-dom/client';
import { AppRegistry } from 'react-native';
import { enableScreens } from 'react-native-screens';
import { PwaApp } from './PwaApp';
import './pwa.css';

/**
 * Native-stack + react-native-screens on web can leave the active route with
 * `display: none` (blank page). Disable the native screen container on PWA and
 * let navigators use plain Views.
 */
enableScreens(false);

const root_el = document.getElementById('root');
if (!root_el) {
  throw new Error('PWA root element #root not found');
}

AppRegistry.registerComponent('EataamiPWA', () => PwaApp);

createRoot(root_el).render(<PwaApp />);
